const PRODUCT_CATEGORIES = 
[
    {
        companyName: 'Ralphs',
        categories:[
     
            "Fresh Fruit",
            "Snacks",
          
            "Fresh Vegetables",
            "Water",
            
            "Milk",
            "Eggs",
            "Bacon",

          
            "Bread",
            "Deli Meats",
            "Cheese",
          
            "Butter",
            "Peanut Butter",
            "Jams & Jellies",
          
            "Cereal",
            "Granola",
            "Oatmeal",
          
            "Coffee K-Cups",
            "Coffee Beans",
            "Green Tea Bags",
          
            "Coffee Creamer",
            "Fresh Juice",
            "Chobani Yogurt",
          
            "Fresh Berries",
            "Ice Cream",
            "Cookies",
          
            "Chips",
            "Pretzels",
            "Popcorn",
          
            "Ritz",
            "Goldfish",
            "Fruit Snacks",
          
            "Granola Bars",
            "Breakfast Bars",
            "Snack Bars",
          
            "Meats",
            "Chicken",
            "Beef",
          
            "Condiments",
            "Cooking Oil",
            "Spices",
          
            "Tortilla Chips",
            "Salsa",
            "Guacamole",
          
            "Sabra Hummus",
            "Pita Chips",
            "Trail Mix",
          
            "Nuts",
            "Dried Fruit",
            "Organic Fruit",
          
            "Donuts and Pastries",
            "Cookie Dough",
            "Cinnamon Rolls",
          
            "Frozen Breakfast",
            "Frozen Pizza",
            "Frozen Snacks",
          
            "Frozen Vegetables",
            "Non-Stick Cooking Spray",
            "Aluminum Foil",
          
            "Soft Drinks",
            "Sports Drinks",
            "Energy Drink Variety Pack",
            "Pedialyte",
          
            "Beer",
            "Red Wine",
            "Liquor",
          
            "Hard Seltzer",
            "IPA Beer",
            "Non-Alcoholic Beer",
          
            "Charcoal",
            "Paper Plates",
            "Plastic Cutlery",
          
            "Paper Towels",
            "Toilet Paper",
            "Trash Bags",
            "Napkins",
          
            "Party Trays",
            "Flower Bouquet",
          
            "Toothbrush",
            "Toothpaste",
            "Shaving Cream",
          
            "Sanitizer Wipes",
            "Pain Relief",
            "Sunscreen",
          
            "Insect Repellent",
            "Disposable Razors",
            "First Aid Kit",
          
            "Gluten-Free Snacks",
            "Vegan Alternatives",
          
            "Baby Diapers",
            "Baby Foods",
            "Baby Wipes",
          
            "Pet Food",
            "Dog Treats"
          ]
          
          
    }, 
    {
        companyName: 'Sprouts',
        categories: [
            "Produce", "Fruits", "Vegetables", "Toppings, Refrigerated Dressings & Dips", "Floral",
            "Deli", "Deli Meats & Cheese", "Specialty & Domestic Cheeses", "Heat & Eat", "Ready To Eat", "Snacks",
            "Beverages",
            "Bakery", "Bread", "Tortillas & Flat Breads", "Baked Goods & Desserts",
            "Bulk", "Fruit & Nuts", "Bulk Baking & Spices", "Coffee & Tea", "Snacks & Sweets", "Beans, Peas & Grains", "Granola & Cereal", "Nut Butter & Honey",
            "Dairy", "Milk", "Butter & Spreads", "Eggs", "Yogurts", "Cultured", "Plant-Based Alternatives", "Refrigerated Baking & Raw Foods", "Refrigerated Beverages",
            "Meat & Seafood", "All Natural Beef", "All Natural Poultry", "All Natural Pork", "Grass Fed Lamb", "Sausage", "Further Prepared Meats", "Prepackaged/Smoked", "Seafood", "Frozen", "Bison",
            "Grocery Aisles", "Snacks", "Nutrition Bars", "Beverages", "Breakfast", "Baking & Spices", "Soups, Broths & Sauces", "Nut Butters & Fruit Spreads", "Oils & Dressings", "Baby Care", "Honey & Syrups", "Canned & Dry Goods", "Condiments", "Meals", "International Foods", "Household", "Pet Care",
            "Frozen", "Entrees", "Plant-Based", "Snacks & Pizzas", "Appetizers & Burritos", "Frozen Fruits", "Frozen Vegetables", "Frozen Potatoes", "Breakfast Foods", "Desserts & Tortillas", "Ice Cream & Novelties", "Ice",
            "Vitamins & Body Care", "Supplements", "Nutritional Oils", "Wellness", "Body Care",
            "Beer & Wine", "Red Wine", "White Wine", "Rose & Blush", "Champagne & Sparkling", "Beer", "Non-Alcoholic", "Sweet Wines", "Specialty"
        ]
    },
    {
        companyName: 'WholeFoods',
        categories: [
            "Pet",
            "Meat",
            "Beauty",
            "Produce",
            "Seafood",
            "Desserts",
            "Beverages",
            "Body Care",
            "Household",
            "Lifestyle",
            "Baby Child",
            "Dairy Eggs",
            "Supplements",
            "Frozen Foods",
            "Prepared Foods",
            "Pantry Essentials",
            "Wine Beer Spirits",
            "Breads Rolls Bakery",
            "Snacks Chips Salsas Dips"
        ]

    },
    {
        companyName: 'Vons',
        categories: [
            'Fresh Fruits',
            'Fresh Vegetables',
            'Packaged Produce',
            'Cereal',
            'Meat & Seafood',
            'Bakery',
            'Bread & Bakery',
            'Beverages',
            'Coffee',
            'Tea',
            'Breakfast Bars',
            'Soft Drinks',
            'Snacks & Candy',
            'Toaster Pastries',
            'Syrup',
            'Chicken & Turkey',
            'Beef',
            'Fish & Shellfish',
            'Nuts & Dried Fruits',
            'Dairy',
            'Milk & Cream',
            'Cheese',
            'Butter & Sour Cream',
            'Deli',
            'Deli Specialty Foods',
            'Deli Soups',
            'Deli Sides & Meals',
            'Bulk Foods',
            'Sushi',
            'Cookies & Bakery Snacks',
            'Cakes & Cupcakes',
            'Frozen',
            'Frozen Vegetables',
            'Frozen Meals & Sides',
            'Pasta Sauce',
        ]
    }
]
 
 
 export default PRODUCT_CATEGORIES;
